import gql from 'graphql-tag';
export default gql`
  query user($email: String!, $appCode: String!) {
    user(email: $email, appCode: $appCode) {
      id
      first_name
      last_name
      email
      organisation {
        id
        name
        org_branding {
          logo
          brand_name
        }
      }
      features {
        id
        name
        code
      }
      org_id
    }
  }
`;
